const WarningSVG = () => {
    return (
        <svg
            fill="none"
            height="186"
            viewBox="0 0 186 186"
            width="186"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                clipRule="evenodd"
                d="M72.5336 41.8251L71.4214 44.421L70.6423 47.2062L57.8658 140.354L57.4411 143.403L57.4446 146.275L57.8434 148.938L58.6055 151.355L59.6991 153.488L61.092 155.297L62.7523 156.74L64.6461 157.774L66.7391 158.354L68.9954 158.436L71.378 157.974L73.8476 156.923L155.332 113.552L158.167 111.684L160.617 109.419L162.661 106.835L164.281 104.011L165.462 101.025L166.188 97.9598L166.448 94.8938L166.232 91.9065L165.533 89.0757L164.345 86.4772L162.662 84.1848L160.483 82.2698L91.9665 32.9138L90.0363 31.8944L87.975 31.4L85.8327 31.3907L83.6581 31.8276L81.4989 32.6732L79.4014 33.8914L77.4112 35.4478L75.5734 37.3095L73.9326 39.4452L72.5336 41.8251Z"
                fill="url(#paint0_linear_336_4377)"
                fillOpacity="0.35"
                fillRule="evenodd"
            />
            <g filter="url(#filter0_b_336_4377)">
                <path
                    clipRule="evenodd"
                    d="M163.337 83.5917L161.102 81.6157L95.3786 34.8639L92.0614 32.9016L88.6867 30.9052L85.2528 28.8738L81.7586 26.8068L78.2018 24.7027L144.762 72.3514L147.036 74.3857L148.796 76.8158L150.044 79.5666L150.785 82.56L151.025 85.7161L150.772 88.9527L150.035 92.1863L148.825 95.3326L147.158 98.3069L145.05 101.025L142.518 103.403L139.585 105.361L53.8119 152.551L51.2532 153.648L48.7818 154.124L46.4384 154.025L50.456 155.033L54.4 156.023L58.2725 156.995L62.0753 157.949L65.8104 158.886L68.1187 158.998L70.5444 158.561L73.0467 157.528L156.409 113.13L159.243 111.29L161.682 109.045L163.704 106.47L165.295 103.646L166.439 100.653L167.122 97.5703L167.336 94.479L167.07 91.4582L166.318 88.5861L165.075 85.9392L163.337 83.5917Z"
                    fill="url(#paint1_linear_336_4377)"
                    fillOpacity="0.6"
                    fillRule="evenodd"
                />
            </g>
            <g filter="url(#filter1_b_336_4377)">
                <path
                    clipRule="evenodd"
                    d="M58.0709 34.008L56.9302 36.7435L56.1363 39.6806L37.1259 134.966L36.7015 138.183L36.7208 141.217L37.1493 144.032L37.9539 146.589L39.101 148.847L40.5573 150.765L42.2891 152.298L44.2612 153.4L46.4378 154.025L48.7811 154.123L51.2526 153.648L53.8113 152.551L139.584 105.36L142.517 103.403L145.049 101.025L147.158 98.3068L148.825 95.3325L150.034 92.1862L150.771 88.9525L151.025 85.716L150.785 82.5599L150.044 79.5665L148.795 76.8157L147.035 74.3856L144.762 72.3513L78.2012 24.7026L76.1914 23.6154L74.0483 23.0822L71.8237 23.0607L69.5681 23.5102L67.3305 24.3915L65.1592 25.6666L63.1011 27.2995L61.2029 29.2556L59.5107 31.5022L58.0709 34.008Z"
                    fill="url(#paint2_linear_336_4377)"
                    fillOpacity="0.2"
                    fillRule="evenodd"
                />
                <path
                    d="M61.2624 32.6588L59.9536 34.9367L58.9168 37.4229L58.1771 40.1595L39.194 135.308L38.7974 138.314L38.8148 141.052L39.1962 143.557L39.9003 145.794L40.8836 147.73L42.1007 149.333L43.5085 150.579L45.0719 151.453L46.7756 151.942L48.6254 152.02L50.6349 151.634L52.8913 150.666L138.496 103.568L141.21 101.757L143.495 99.6105L145.407 97.1461L146.923 94.4399L148.025 91.5744L148.695 88.6362L148.924 85.7136L148.709 82.8935L148.056 80.257L146.975 77.8736L145.471 75.7967L143.45 73.9885L77.0887 26.4827L75.4281 25.5844L73.7816 25.1747L72.0204 25.1577L70.1614 25.5282L68.2504 26.2809L66.3465 27.399L64.5098 28.8562L62.7976 30.6207L61.2624 32.6588Z"
                    stroke="url(#paint3_linear_336_4377)"
                    strokeWidth="4.1901"
                />
            </g>
            <g filter="url(#filter2_d_336_4377)">
                <path
                    clipRule="evenodd"
                    d="M74.5992 46.5542L74.8198 46.7587L77.6659 47.7198L77.4645 47.4506L77.2434 47.2469L74.5992 46.5542ZM77.0031 47.1085L74.3608 46.4158L74.3591 46.4153L74.5992 46.5542L77.2417 47.2464L77.2434 47.2469L77.0031 47.1085ZM74.8198 46.7587L77.6659 47.7198L77.8479 48.0544L75.2024 47.3653L75.0211 47.0291L74.8198 46.7587ZM76.9657 47.0986L77.0031 47.1085L76.9997 47.1075L76.7434 47.0352L74.1373 46.3519L74.0997 46.342L74.103 46.343L74.3591 46.4153L76.9657 47.0986ZM75.2024 47.3653L77.8479 48.0544L78.0102 48.4547L78.1531 48.9206L87.704 85.2616L87.7044 85.263L87.8082 85.7216L87.8731 86.161L87.8991 86.581L87.886 86.9814L87.8343 87.3621L87.7435 87.7231L87.6137 88.0642L87.4453 88.3851L87.2381 88.6861L86.9922 88.967L86.7078 89.2277L86.3848 89.4681L82.635 91.9935L82.3065 92.1919L81.9947 92.3334L81.6997 92.4183L81.4213 92.4465L79 91.9825L78.9991 91.9823L79.2941 91.8967L79.606 91.754L79.9347 91.5541L83.6875 89.0097L84.0106 88.7675L84.2954 88.5049L84.5417 88.2221L84.7493 87.919L84.9182 87.5959L85.0486 87.2527L85.1395 86.8894L85.1918 86.5063L85.2055 86.1036L85.1801 85.681L85.1153 85.2391L85.0121 84.7778L75.5069 48.2372L75.5065 48.2359L75.3642 47.7675L75.2024 47.3653ZM86.8176 110.778L87.1924 110.569L92.2572 107.376L92.6271 107.116L92.9513 106.829L93.2295 106.517L93.4619 106.178L93.6478 105.814L93.7875 105.424L93.8808 105.008L93.9277 104.567L93.9283 104.101L93.8824 103.609L93.7901 103.093L93.6517 102.552L91.9317 96.657L91.7627 96.1443L91.5748 95.699L91.3679 95.3207L91.1421 95.0096L90.8974 94.7654L90.6338 94.588L90.3515 94.4774L87.6495 94.0454L87.6486 94.0453L87.9307 94.1563L88.194 94.3345L88.4385 94.5799L88.664 94.8928L88.8705 95.2731L89.0579 95.721L89.2263 96.2367L90.9398 102.166L91.0777 102.711L91.1693 103.23L91.2145 103.725L91.2135 104.194L91.166 104.638L91.0722 105.056L90.932 105.449L90.7455 105.815L90.5129 106.156L90.2342 106.471L89.9096 106.759L84.47 110.238L84.0947 110.449L83.7389 110.593L83.4032 110.67L85.8098 111.008L86.126 110.998L86.462 110.921L86.8176 110.778ZM83.4032 110.67L83.0865 110.681L85.8098 111.008L83.4032 110.67Z"
                    fill="url(#paint4_linear_336_4377)"
                    fillRule="evenodd"
                />
                <path
                    clipRule="evenodd"
                    d="M73.5232 46.3917L73.5233 46.3917L73.5233 46.3917L73.5233 46.3917L73.8214 46.3342L74.1003 46.3421L74.1003 46.3421L74.1003 46.3421L74.3597 46.4154L74.5997 46.5542L74.5998 46.5542L74.5998 46.5542L74.8204 46.7588L75.0214 47.0291L75.0215 47.0291L75.0215 47.0291L75.0215 47.0291L75.0215 47.0291L74.1003 46.3421L74.1003 46.3421L74.1003 46.3421L75.0214 47.0291L75.3648 47.7675L75.5071 48.2359L85.0122 84.7756L85.0128 84.7778L85.116 85.2391L85.1804 85.681L85.2059 86.1035L85.1925 86.5063L85.1402 86.8894L85.049 87.2526L84.9189 87.5959L84.75 87.9191L84.5424 88.2221L84.2961 88.5049L84.0113 88.7674L83.6882 89.0097L79.9354 91.5541L79.6067 91.754L79.2948 91.8967L78.9997 91.9824L78.7212 92.0111L78.4595 91.9829L78.4595 91.9829L78.4594 91.9828L78.2144 91.8979L77.9862 91.7565L77.986 91.7564L77.9859 91.7563L77.9858 91.7563L77.9857 91.7562L77.7739 91.5582L77.5786 91.3038L77.5785 91.3036L77.2371 90.6255L77.237 90.6253L77.0909 90.2017L66.4167 55.2574L66.4166 55.2569L66.2929 54.7856L66.2108 54.3313L66.1706 53.8942L66.1721 53.4743L66.2154 53.0713L66.3004 52.6852L66.4271 52.3157L66.5956 51.9629L66.8061 51.6266L67.0585 51.3066L67.3531 51.003L67.6901 50.7156L72.5133 46.9545L72.8691 46.702L72.8691 46.702L72.8693 46.7018L73.2058 46.5143L73.5231 46.3917L73.5232 46.3917ZM77.5783 91.3036L77.3994 90.9926L77.2369 90.6253L77.5783 91.3036ZM79.4327 100.129L79.5235 99.7228L79.6582 99.3405L79.8367 98.9823L80.0591 98.6482L80.3256 98.338L80.6363 98.0517L80.6363 98.0517L80.9914 97.7893L85.9571 94.492L86.3328 94.2696L86.6899 94.1135L87.0284 94.024L87.3481 94.0012L87.6491 94.0453L87.9313 94.1563L87.9314 94.1563L87.932 94.1569L88.1946 94.3345L88.4383 94.5793L88.4392 94.58L88.4398 94.5809L88.6646 94.8928L88.8705 95.272L88.871 95.273L88.8712 95.2731L88.8713 95.2736L88.8718 95.2749L89.0585 95.7211L89.2268 96.2364L89.2269 96.2367L90.9404 102.166L91.0782 102.711L91.1698 103.23L91.2151 103.725L91.214 104.194L91.1666 104.638L91.1666 104.638L91.1665 104.638L91.0727 105.056L90.9325 105.449L90.746 105.815L90.5134 106.156L90.5133 106.156L90.5129 106.157L90.2347 106.471L89.9107 106.759L89.9102 106.759L84.4705 110.238L84.0952 110.449L83.7396 110.593L83.4036 110.67L83.0872 110.681L82.7903 110.626L82.5132 110.504L82.5129 110.504L82.5128 110.504L82.2548 110.316L82.0163 110.062L82.0161 110.061L82.016 110.061L82.0158 110.061L81.797 109.742L81.5972 109.356L81.597 109.356L81.4162 108.904L81.2546 108.387L81.2546 108.387L79.635 102.531L79.5069 102.001L79.4226 101.496L79.3822 101.016L79.3856 100.56L79.4327 100.129ZM79.3822 101.016L79.5069 102.001L81.2546 108.387L79.5069 102.001L79.3823 101.016L79.6582 99.3405L79.6582 99.3405L79.3822 101.016ZM75.203 47.3653L75.0215 47.0291L75.3649 47.7675L75.203 47.3653Z"
                    fill="url(#paint5_linear_336_4377)"
                    fillOpacity="0.8"
                    fillRule="evenodd"
                />
            </g>
            <defs>
                <filter
                    colorInterpolationFilters="sRGB"
                    filterUnits="userSpaceOnUse"
                    height="385.702"
                    id="filter0_b_336_4377"
                    width="372.304"
                    x="-79.2647"
                    y="-101"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feGaussianBlur
                        in="BackgroundImageFix"
                        stdDeviation="62.8516"
                    />
                    <feComposite
                        in2="SourceAlpha"
                        operator="in"
                        result="effect1_backgroundBlur_336_4377"
                    />
                    <feBlend
                        in="SourceGraphic"
                        in2="effect1_backgroundBlur_336_4377"
                        mode="normal"
                        result="shape"
                    />
                </filter>
                <filter
                    colorInterpolationFilters="sRGB"
                    filterUnits="userSpaceOnUse"
                    height="240.005"
                    id="filter1_b_336_4377"
                    width="223.266"
                    x="-17.7702"
                    y="-31.4107"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feGaussianBlur
                        in="BackgroundImageFix"
                        stdDeviation="27.2357"
                    />
                    <feComposite
                        in2="SourceAlpha"
                        operator="in"
                        result="effect1_backgroundBlur_336_4377"
                    />
                    <feBlend
                        in="SourceGraphic"
                        in2="effect1_backgroundBlur_336_4377"
                        mode="normal"
                        result="shape"
                    />
                </filter>
                <filter
                    colorInterpolationFilters="sRGB"
                    filterUnits="userSpaceOnUse"
                    height="148.476"
                    id="filter2_d_336_4377"
                    width="111.56"
                    x="7.50944"
                    y="17.0035"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        result="hardAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    />
                    <feOffset dx="-16.7604" dy="12.5703" />
                    <feGaussianBlur stdDeviation="20.9505" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.333333 0 0 0 0 0.260549 0 0 0 0 0.207843 0 0 0 0.3 0"
                    />
                    <feBlend
                        in2="BackgroundImageFix"
                        mode="normal"
                        result="effect1_dropShadow_336_4377"
                    />
                    <feBlend
                        in="SourceGraphic"
                        in2="effect1_dropShadow_336_4377"
                        mode="normal"
                        result="shape"
                    />
                </filter>
                <linearGradient
                    gradientUnits="userSpaceOnUse"
                    id="paint0_linear_336_4377"
                    x1="175.085"
                    x2="45.7395"
                    y1="133.818"
                    y2="38.4975"
                >
                    <stop offset="0.268633" stopColor="#FFCEBC" />
                    <stop offset="0.763637" stopColor="#FFD0BF" />
                </linearGradient>
                <linearGradient
                    gradientUnits="userSpaceOnUse"
                    id="paint1_linear_336_4377"
                    x1="179.216"
                    x2="82.2827"
                    y1="13.9953"
                    y2="176.217"
                >
                    <stop offset="0.325115" stopColor="#15192C" />
                    <stop offset="0.614837" stopColor="#FF8C63" />
                    <stop offset="1" stopColor="#6B37FF" />
                </linearGradient>
                <linearGradient
                    gradientUnits="userSpaceOnUse"
                    id="paint2_linear_336_4377"
                    x1="159.498"
                    x2="22.769"
                    y1="127.752"
                    y2="29.0107"
                >
                    <stop offset="0.268633" stopColor="#FF8C63" />
                    <stop offset="0.763637" stopColor="#6B37FF" />
                </linearGradient>
                <linearGradient
                    gradientUnits="userSpaceOnUse"
                    id="paint3_linear_336_4377"
                    x1="154.19"
                    x2="92.2822"
                    y1="94.6636"
                    y2="68.3187"
                >
                    <stop stopColor="white" stopOpacity="0.54" />
                    <stop offset="0.688828" stopColor="white" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    gradientUnits="userSpaceOnUse"
                    id="paint4_linear_336_4377"
                    x1="88.0915"
                    x2="66.785"
                    y1="61.6574"
                    y2="68.7756"
                >
                    <stop offset="0.334199" stopColor="#FEA282" />
                    <stop offset="0.590808" stopColor="#FF8C63" />
                </linearGradient>
                <linearGradient
                    gradientUnits="userSpaceOnUse"
                    id="paint5_linear_336_4377"
                    x1="59.3869"
                    x2="37.8616"
                    y1="116.848"
                    y2="99.7616"
                >
                    <stop
                        offset="0.306695"
                        stopColor="white"
                        stopOpacity="0.85"
                    />
                    <stop offset="1" stopColor="#E7D4B7" stopOpacity="0.64" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default WarningSVG;
